function FeatureBoxWrapper({ children }) {
    return (
        <div className="grid w-full md:grid-cols-3 grid-cols-1 md:gap-2 gap-4">
            {children}
        </div>
    )
}

export default FeatureBoxWrapper
